// extracted by mini-css-extract-plugin
export var frame = "FramedLayout-module--frame--e8b18";